import React, { useEffect } from 'react';
import axios from 'axios';

const AdPage = () => {
  useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        const response = await axios.get('/api/admin/ads/redirect');
        const { url } = response.data;
        if (url) {
          // Capture detailed traffic data before redirect
          const trafficData = {
            // Browser and device info
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            viewportWidth: window.innerWidth,
            viewportHeight: window.innerHeight,
            devicePixelRatio: window.devicePixelRatio,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            language: navigator.language,
            languages: navigator.languages,
            platform: navigator.platform,
            cookieEnabled: navigator.cookieEnabled,
            online: navigator.onLine,

            // Page and referrer info
            pageUrl: window.location.href,
            pageTitle: document.title,

            // Performance timing (if available)
            loadTime: performance.timing ? performance.timing.loadEventEnd - performance.timing.navigationStart : null,

            // Marketing attribution
            gclid: new URLSearchParams(window.location.search).get('gclid'), // Google Ads
            fbclid: new URLSearchParams(window.location.search).get('fbclid'), // Facebook Ads
            msclkid: new URLSearchParams(window.location.search).get('msclkid'), // Microsoft Ads

            // Custom tracking parameters
            sessionId: sessionStorage.getItem('sessionId') || generateSessionId(),
            visitorId: localStorage.getItem('visitorId') || generateVisitorId()
          };

          // Send traffic data to capture endpoint
          await axios.post('/api/admin/ads/capture-traffic', trafficData, {
            params: {
              utm_source: new URLSearchParams(window.location.search).get('utm_source'),
              utm_medium: new URLSearchParams(window.location.search).get('utm_medium'),
              utm_campaign: new URLSearchParams(window.location.search).get('utm_campaign'),
              utm_term: new URLSearchParams(window.location.search).get('utm_term'),
              utm_content: new URLSearchParams(window.location.search).get('utm_content')
            }
          });

          // Redirect to target URL
          window.location.href = url;
        }
        // If no URL configured, just show blank page (no redirect)
      } catch (error) {
        console.error('Error in ad redirect process:', error);
        // On error, just show blank page
      }
    };

    fetchAndRedirect();
  }, []);

  // Helper functions for tracking
  const generateSessionId = () => {
    const sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('sessionId', sessionId);
    return sessionId;
  };

  const generateVisitorId = () => {
    const visitorId = `visitor_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('visitorId', visitorId);
    return visitorId;
  };

  // Show loading animation while processing redirect
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600 flex items-center justify-center">
      <div className="text-center">
        {/* Animated spinner */}
        <div className="relative">
          <div className="w-20 h-20 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto mb-6"></div>
          <div className="absolute inset-0 w-20 h-20 border-4 border-transparent border-r-blue-300 rounded-full animate-spin mx-auto" style={{animationDirection: 'reverse', animationDuration: '1s'}}></div>
        </div>

        {/* ? text with fade animation */}
        <div className="text-white">
          <h1 className="text-2xl font-bold mb-2 animate-pulse">Redirecting...</h1>
          <p className="text-white/80 animate-pulse" style={{animationDelay: '0.5s'}}>Please wait</p>
        </div>

        {/* Dots animation */}
        <div className="flex justify-center space-x-2 mt-4">
          <div className="w-3 h-3 bg-white rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
          <div className="w-3 h-3 bg-white rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
        </div>
      </div>
    </div>
  );
};

export default AdPage;
